import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import * as CreDtos from "../../CRE.dtos";
import { bindActionCreators } from "redux";
import { PublishedItem } from './../Publications/PublishedItem';

interface IResourcesGridProps {
    resources: CreDtos.Publication[];
    isLoading: boolean;
    location: any;
}

class ResourcesGrid extends React.Component<IResourcesGridProps, any> {
    constructor(props: IResourcesGridProps) {
        super(props);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {

        if (!this.props.resources || this.props.isLoading) {
            return (<div></div>);
        }

        let resources = this.props.resources.map((item, index) => {
            let anchor = item.anchor;
            if (!anchor) {
                anchor = item.id.toString();
            }
            let titleHtml = item.title;
            if (item.titleExt && item.titleExt.length > 0) {
                titleHtml = titleHtml +  ' ' + item.titleExt;
            }
            return <div key={index} className="col-3 menu-card research-card mx-2 my-2">
                <div className="vertical-align-middle">
                    <Link to={`/ResourceItem/${anchor}`}>
                        <div style={{ height: "50px" }} dangerouslySetInnerHTML={{ __html: titleHtml }}></div>
                        <div className="py-3 yellow-text" >&#8594;</div >
                    </Link>
                </div>
            </div>;
        });
        return (
            <div id="SectionContainer">
                <section className="content">
                    <div className="container">
                        <h1>Resources</h1>
                        <p>This section features resources that have been created or adapted for Indigenous Australians.
                            More resources that will be developed by our research projects will be added over time.
                            For more information about resources, <a className="muted-link" href="/ContactUs?type=other&msg=more information about resources">contact us</a>.</p>
                        <p>Resources available to download for free: </p>
                        <div className="row">
                            {resources}
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        resources: state.siteData.siteData.resources,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};


const ResourcesContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(
    ResourcesGrid
));

export default ResourcesContainer;



// WEBPACK FOOTER //
// ./src/components/Resources/ResourcesGrid.tsx